/**
 * Created by Ella Ma on 2020/09/10.
 * ------ maintenance history ------
 */

import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { WorkflowDialogConfig, WorkflowDialogOperations } from '../workflow-model';

@Injectable()
export class WorkflowDialogService {

    import$: Subject<any> = new Subject<any>();
    open$: Subject<WorkflowDialogConfig> = new Subject<WorkflowDialogConfig>();
    openFileBrowserDialog$: Subject<any> = new Subject<any>();
    result$: Subject<any> = new Subject<any>();
    edit$: Subject<any> = new Subject<any>();

    open(opType = WorkflowDialogOperations.NEW, data?: any, disabledCancel?: boolean) {
        const config: WorkflowDialogConfig = {
            opType: opType,
            data: data,
            disabledCancel: !!disabledCancel
        };
        this.open$.next(config);
        return this.result$;
    }

    openFileBrowserDialog(event) {
        this.openFileBrowserDialog$.next(event);
    }
}
